module.exports = __webpack_public_path__ + "static/media/img1-5.691fd675.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img1-5.png
// module id = 1430
// module chunks = 3